module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "allmap",
    attrs: {
      "id": "allmap"
    }
  }), _vm._v(" "), _c('group', [_c('cell-box', {
    attrs: {
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeArea()
      }
    }
  }, [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "flex-demo home-list-title"
  }, [_c('p', {
    staticClass: "item-p"
  }, [_vm._v("考勤地点")])])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo home-list-date"
  }, [_vm._v(_vm._s(_vm.popupData))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.appSign()
      }
    }
  }, [_vm._v("开始打卡")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("定位：" + _vm._s(_vm.selectArea) + " "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.reGetLocation()
      }
    }
  }, [_vm._v("重新定位")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.areaCtrl),
      callback: function($$v) {
        _vm.areaCtrl = $$v
      },
      expression: "areaCtrl"
    }
  }, [_c('popup-header', {
    attrs: {
      "title": "选择附近的考勤地点",
      "show-bottom-border": false
    },
    on: {
      "on-click-left": function($event) {
        _vm.areaCtrl = false
      },
      "on-click-right": function($event) {
        _vm.areaCtrl = false
      }
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('radio', {
    attrs: {
      "options": _vm.nearbyAddress,
      "title": _vm.nearbyAddress
    },
    on: {
      "on-change": _vm.changePlace
    },
    model: {
      value: (_vm.popupData),
      callback: function($$v) {
        _vm.popupData = $$v
      },
      expression: "popupData"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4278e80e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendance/Attendance-compoment.vue
// module id = JyIH
// module chunks = 1